import { Tooltip } from 'platform/components';
import { Image } from 'platform/foundation';
import { CellRendererProps } from '../../types/CellRendererProps';
import { getTooltipProps } from '../../utils/getTooltipProps';

// thumbnailHeightPx is pre-computed in GridCell as rowHeightPx - verticalPaddingPx.
// This avoids a per-cell store subscription — the computation lives in GridRow
// (1 subscription per row) and is threaded down via renderCell.
type ThumbnailCellRendererProps = CellRendererProps<string | null> & {
  thumbnailHeightPx: number;
};
export function ThumbnailCellRenderer(props: ThumbnailCellRendererProps) {
  const tooltipProps = getTooltipProps(props.row, {});
  if (!props.value) {
    return null;
  }
  const imageHeightCss = `calc(${props.thumbnailHeightPx}px)` as const;
  return <div className="flex items-center [&_img]:rounded">
      <Tooltip {...tooltipProps} isDisabled={false} label={<Image fit="contain" src={`${props.value}&height=500`} />}>
        <Image fit="contain" height={imageHeightCss} src={`${props.value}&height=${props.thumbnailHeightPx}`} />
      </Tooltip>
    </div>;
}